import React, { useState } from "react";

import { isValidDateFormat } from "../../shared/utils/date-utils";

export const SearchForm = ({ onSearch, loading }) => {
  const [clientId, setClientId] = useState("");
    const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [error, setError] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Валидация ввода
    if (!clientId.trim()) {
      setError("Необходимо ввести Client ID");
      return;
    }

    

    // Сбрасываем ошибку и запускаем поиск
    setError(null);
    // Валидация дат, если они введены
    if (startDate.trim() && !isValidDateFormat(startDate)) {
      setError(
        "Неверный формат начальной даты. Используйте ДД.ММ.ГГГГ."
      );
      return;
    }
    if (endDate.trim() && !isValidDateFormat(endDate)) {
      setError(
        "Неверный формат конечной даты. Используйте ДД.ММ.ГГГГ."
      );
      return;
    }

    // Сбрасываем ошибку и запускаем поиск
    setError(null);
    onSearch(clientId, startDate.trim(), endDate.trim());
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="space-y-4">
          <div>
            <label
              htmlFor="clientId"
              className="block text-sm font-medium text-gray-300 mb-2"
            >
              Client ID
            </label>
            <input
              id="clientId"
              type="text"
              value={clientId}
              onChange={(e) => setClientId(e.target.value)}
              placeholder="Введите Client ID"
              className="w-full bg-white border border-gray-300 rounded-md p-2.5 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-purple-500 transition-colors"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="startDate" className="block text-sm font-medium text-gray-300 mb-2">
                Начальная дата (ДД.ММ.ГГГГ)
              </label>
              <input
                id="startDate"
                type="text"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                placeholder="Например: 13.03.2025"
                className="w-full bg-white border border-gray-300 rounded-md p-2.5 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-purple-500 transition-colors"
              />
            </div>
            <div>
              <label htmlFor="endDate" className="block text-sm font-medium text-gray-300 mb-2">
                Конечная дата (ДД.ММ.ГГГГ)
              </label>
              <input
                id="endDate"
                type="text"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                placeholder="Например: 19.03.2025"
                className="w-full bg-white border border-gray-300 rounded-md p-2.5 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-purple-500 transition-colors"
              />
            </div>
          </div>

          <div className="flex items-end mt-6">
            <button
              type="submit"
              disabled={loading}
              className="gradient-button w-full py-2.5 px-4"
            >
              {loading ? (
                <span className="flex items-center justify-center">
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-gray-900" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Загрузка...
                </span>
              ) : "Получить сделки"}
            </button>
          </div>
        </div>
      </form>

      {/* Сообщение об ошибке */}
      {error && (
        <div className="mt-4 bg-red-50 border border-red-300 text-red-700 p-3 rounded-md flex items-start">
          <svg className="h-5 w-5 text-red-500 mr-2 mt-0.5 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
          </svg>
          <p>{error}</p>
        </div>
      )}
    </div>
  );
};

export default SearchForm;
